// 2020-06-27export { QuickPanelComponent } from './quick-panel.component';